module.exports = __webpack_public_path__ + "img/01.7a3989b9.png";